<template>
  <div class="PlanosMarketplaces" v-loading="loadingPage">
    <div class="clearfix">
      <el-button @click="() => {dialogVisible = true}" style="float: right" type="primary" plain>Associar</el-button>
    </div>
    <TableSimple :list-data="listData" @paginationClick="paginationClick">
      <el-table-column prop="id" label="#" width="80">
      </el-table-column>
      <el-table-column prop="plan.name" label="Plano">
      </el-table-column>
      <el-table-column prop="status" label="Status" width="150">
        <template slot-scope="scope">
            <span v-if="scope.row.status === 'active'">
              <el-tag size="small" type="success">Ativo</el-tag>
            </span>
          <span v-else>
              <el-tag size="small" type="warning">Desativado</el-tag>
            </span>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="Atualizado em" width="200">
        <template slot-scope="scope">
           <span>{{ moment(scope.row.created_at).format('DD/MM/YYYY') }}</span>
        </template>
      </el-table-column>
      <el-table-column width="140">
        <template slot-scope="scope">
          <el-button @click="submitDesassociar(scope.row.id)" size="small" type="danger" v-if="scope.row.status  === 'active'" plain>Desassociar</el-button>
        </template>
      </el-table-column>
    </TableSimple>
    <el-dialog title="Associar Plano ao MarketPlace" :visible.sync="dialogVisible" :before-close="handleClose">
      <el-form v-loading="loadingPageplan" v-if="dialogVisible" :model="ruleFormPlan" ref="ruleFormPlan" @submit.prevent v-on:submit.prevent>
        <el-form-item prop="plan_id_anticipated" label="Plano (Antecipado)" :error="error.plan_id_anticipated">
          <SelectSearchPlanos :queryString="'&anticipation=1&type=marketplace'" :model="ruleFormPlan.plan_id_anticipated" :isEdit="false" @handleValue="(x) => {ruleFormPlan.plan_id_anticipated = x}"  />
        </el-form-item>
        <el-form-item prop="plan_id_no_anticipated" label="Plano (Não antecipado)" :error="error.plan_id_no_anticipated">
          <SelectSearchPlanos :queryString="'&anticipation=0&type=marketplace'" :model="ruleFormPlan.plan_id_no_anticipated" :isEdit="false" @handleValue="(x) => {ruleFormPlan.plan_id_no_anticipated = x}"  />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="float: left" @click="() => {dialogVisible = false; $refs['ruleFormPlan'].resetFields()}">Cancelar</el-button>
        <el-button type="primary" native-type="submit" @click.prevent="submitForm('ruleFormPlan')">Associar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TableSimple from "@/app/components/Table/TableSimple";
import {
  getPlanosMarketplaces,
  postDesassociarPlanosMarketplaces,
  postPlanosMarketplaces
} from "@/app/domains/Records/services";
import SelectSearchPlanos from "@/app/components/Planos/SelectSearchPlanos";
import {setFormData} from "@/app/plugins/utils";
import moment from 'moment'
export default {
  name: "PlanosMarketplaces",
  components: {
    TableSimple,
    SelectSearchPlanos,
  },
  props: ['idState'],
  data () {
    return {
      loadingPage: false,
      loadingPageplan: false,
      dialogVisible: false,
      listData: {},
      ruleFormPlan: {
        marketplace_id: this.$route.params.id,
        plan_id_anticipated: '',
        plan_id_no_anticipated: '',
      },
      error: []
    }
  },
  methods: {
    init () {
      this.listPMkt()
    },
    async listPMkt (query = '') {
      this.loadingPage = true
      try {
        let response = {}
        if (this.idState) {
          response = await getPlanosMarketplaces('?marketplace_id='+this.idState+query)
        } else {
          response = await getPlanosMarketplaces('?marketplace_id='+this.$route.params.id+query)
        }
        this.listData = response.data
      } catch (e) {
        this.$message({
          showClose: true,
          message: e.message,
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    },
    paginationClick (arg) {
      this.listPMkt('&page='+arg.page)
    },
    openDialog () {},
    submitDesassociar (id) {
      this.$confirm('Deseja realmente desassociar esse Plano?', '', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        type: 'warning',
        center: true,
      }).then(async () => {
        this.loadingPage = true
        try {
          await postDesassociarPlanosMarketplaces({id: id, data: setFormData({})})
          this.init()
        } catch (e) {
          this.$message({
            showClose: true,
            message: e.message,
            type: 'error',
          })
        } finally {
          this.loadingPage = false
        }
      }).catch(() => {})
    },
    handleClose (done) {
      
      this.ruleFormPlan = {
        marketplace_id: this.$route.params.id,
        plan_id_anticipated: '',
        plan_id_no_anticipated: '',
      }
      done()
    },
    async submitForm (ruleForm) {
      this.$refs[ruleForm].validate(async (valid) => {
        if (valid) {
          this.loadingPageplan = true
          try {
            let response = await postPlanosMarketplaces(setFormData(this.ruleFormPlan))
            this.dialogVisible = false
            this.init()
          } catch (e) {
            this.$message({
              showClose: true,
              message: e.message,
              type: 'error',
            })
          } finally {
            this.loadingPageplan = false
          }
        }
      })
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped>

</style>
